import React from 'react';

// Fungsi utilitas agar bisa dipakai di Hero, Footer, dll
export const openWhatsAppChat = () => {
  // Ganti dengan nomor WhatsApp Anda
  const phoneNumber = '628119970461'; // Format: 62 untuk Indonesia, tanpa + dan 0 di depan
  const message = encodeURIComponent('Halo, saya tertarik dengan produk dan layanan PT. Tri Cipta Integra');
  window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
};

const WhatsAppFloat: React.FC = () => {
  const handleClick = () => {
    openWhatsAppChat();
  };

  return (
    <>
      <style>{`
        .whatsapp-float {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 60px;
          height: 60px;
          background: #25D366;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 1000;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        }

        .whatsapp-float:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
        }

        .whatsapp-float:active {
          transform: scale(0.95);
        }

        .whatsapp-float img {
          width: 32px;
          height: 32px;
        }

        @media (max-width: 768px) {
          .whatsapp-float {
            width: 56px;
            height: 56px;
            bottom: 20px;
            right: 20px;
          }

          .whatsapp-float img {
            width: 28px;
            height: 28px;
          }
        }
      `}</style>
      <div 
        className="whatsapp-float"
        onClick={handleClick}
        aria-label="Hubungi kami via WhatsApp"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
      >
        <img src="/assets/whatsapp.svg" alt="WhatsApp" />
      </div>
    </>
  );
};

export default WhatsAppFloat;

